import GameContainer from './component';

export default GameContainer;
